import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const hero = css`
  display: flex;
  /* Summary anchors left; the card art + toolbar sit right (slices 2/3). */
  justify-content: space-between;
  align-items: flex-start;
  gap: ${spacing(10)};
  flex-wrap: wrap;
`

/* Removed from the visual layout but left in the a11y tree. */
export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export const left = css`
  flex: 1 1 360px;
  min-width: 300px;
`

export const right = css`
  /* Positioning context for the reveal panel, which anchors below the card. */
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${spacing(4)};
`

export const toolbar = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing(2)};
  flex-wrap: wrap;
`
